import { Component, OnInit } from '@angular/core';
import {Message} from "primeng/primeng";
import {Factura} from "./factura.interface";
import {Tienda} from "../tienda/tienda";
import {FacturaService} from "../Services/factura.service";
import {TiendaService} from "../Services/tienda.service";
import {ActivatedRoute} from "@angular/router";
import {UrlService} from "../Services/url.service";

@Component({
  selector: 'app-lista-facturas',
  templateUrl: './lista-facturas.component.html',
  styleUrls: ['./lista-facturas.component.css']
})
export class ListaFacturasComponent implements OnInit {

  msgs: Message[] = [];

  btnNuevo = true;
  btnCancelar = false;
  btnGuardar = false;
  btnGuardarEditar = false;
  panelRequeridos = false;
  loading = false;
  FacturasRegistrados:Factura[];
  FacturaSeleccionado:Factura;
  tipoGuardado = '';
  TiendasRegistrados:Tienda[];
  verEdicionCantidad = false;
  tiendaSeleccionada = 0;
  tiendaId = 0;
  fInicial;
  fFinal;
  verDetalles = false;
  DetalleFacturasRegistrados:any[];
  role = localStorage.getItem('role');

  constructor(private URL:UrlService,
              private servicioFactura:FacturaService,
              private servicioTienda:TiendaService,
              private route: ActivatedRoute,) { }

  ngOnInit() {
    this.obtenerParmTiendaId();
    //this.ListarFacturaTienda();
    this.listarTiendas();
  }
  mensajes(severity,summary,detail){
    this.msgs = [];
    this.msgs.push({severity:severity, summary:summary, detail:detail});
  }
  listarTiendas(){
    this.loading = true;
    this.servicioTienda.getTienda()
      .subscribe(
        rt => {
          this.TiendasRegistrados = rt;
          this.loading = false;
        },
        er => this.mensajes('error','Error',er),
        () =>  {
        }
      );
  }
  ListarFacturaTienda(){
      this.loading = true;
      let obj = new Object();
      obj['fechaInicial'] = this.fInicial;
      obj['fechaFinal'] =this.fFinal;
      obj['tienda_id'] =this.tiendaId;

      this.servicioFactura.getFacturaByFecha(obj)
        .subscribe(
          rt => {
            this.FacturasRegistrados = rt;
            console.log(rt);
            this.loading = false;
          },
          er => this.mensajes('error','Error',er),
          () =>  {
          }
        );
  }
  CancelarEdicion(){
    this.verEdicionCantidad = false;
  }
  obtenerParmTiendaId(){
    this.route.params
      .subscribe(params => {
        const _id = params['id'].toString();
        this.tiendaId = _id;
      });
  }
  verDetalleFactura(dato){
    this.FacturaSeleccionado = dato;
    this.verDetalles = true;
    this.servicioFactura.getDetallesByPos(dato.id)
      .subscribe(
        rt => {
          this.DetalleFacturasRegistrados = rt;
          this.loading = false;
        },
        er => this.mensajes('error','Error',er),
        () =>  {
        }
      );
  }
  AnularFactura(item){
    let option = confirm('Desea Anular esta factura? recuerde que no se puede deshacer');
    if(option){
      if(this.role = 'Administrador'){
        this.loading = true;
        this.servicioFactura.anularFactura(item.id)
          .subscribe(
            rt => {
              this.mensajes('warn','Atencion',rt);
              this.ListarFacturaTienda();
              this.loading = false;
            },
            er => this.mensajes('error','Error',er),
            () =>  {
            }
          );
      }else{
        this.mensajes('error','Error','Usted no tiene los permisos para relizar esta operacion')
      }
    }

  }
  imprimirFactuturas(item){
    let url:string = this.URL.getLocal()+'/factura/imprimir/'+item.id;
    window.open(url,'blank');
  }
}



// WEBPACK FOOTER //
// H:/Proyectos Galeras Indie/Vinta/vinta Tinka/VintaWebClient/src/app/lista-facturas/lista-facturas.component.ts